import React from 'react';
import { ICacheContext } from 'framework/context/ICacheContext';
import { IProductCatalogSearchData } from 'gen/ApiClient';

export const ProductCatalogFilterDataContext = React.createContext<ICacheContext<IProductCatalogSearchData>>(undefined as any);
